import './HomePage.css'

const HomePage = () => {

  return (
    <>
      <div className="under-construction">
      <h3>Estamos trabajando en esta sección.</h3>
        <img 
          src="https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExYzM5cm1yMW51dzlqcTYwZTJ6d2F0ZDE4bXU2NHNjeTZ5cHV5bGVzbCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/cxNBy7oDovR7DhSxrp/giphy.gif" 
          alt="Under Construction"
        />
        <h3>Calma… lo bueno se hace esperar.</h3>
      </div>
    </>
  )
}

export default HomePage
